import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import { type AtomState } from '@/ui/utilities/state/jotai/types/AtomState';

type CreateAtomStateArgs<TValue> = {
  key: string;
  defaultValue: TValue;
  persistInLocalStorage?: boolean;
};

// Every piece of state gets a stable key, used as its debug label and as its
// storage key when persisted.
export const createAtomState = <TValue>({
  key,
  defaultValue,
  persistInLocalStorage = false,
}: CreateAtomStateArgs<TValue>): AtomState<TValue> => {
  const stateAtom = persistInLocalStorage
    ? atomWithStorage<TValue>(
        key,
        defaultValue,
        createJSONStorage<TValue>(() => localStorage),
        { getOnInit: true },
      )
    : atom(defaultValue);

  stateAtom.debugLabel = key;

  return { type: 'State', key, atom: stateAtom };
};
